import BranchManagerRequest from "../../server/branchManager";
import { addLoading, removeLoading } from "./loading";

export const setBranchManager = (branchManager) => ({
  type: "BRANCH_MANAGER_SET",
  branchManager,
});

export const setBranches = (branches) => ({
  type: "BRANCHES_SET",
  branches,
});



export const getBranchManager = (requestParams) => async (dispatch) => {
  try {
    dispatch(addLoading());
    const branchManager = await BranchManagerRequest.getBranchManager({
      limit: requestParams.limit,
      skip: requestParams.skip,
      search: requestParams.search,
      order: requestParams.order,
      field: requestParams.field,
    });
    dispatch(setBranchManager(branchManager));
    dispatch(removeLoading());
  } catch (error) {
    dispatch(removeLoading());
  }
};

export const updateBranchManager = (updatedFields) => async (dispatch) => {
  try {
    dispatch(addLoading());
    const updatedManager = await BranchManagerRequest.updateBranchManager(
      updatedFields
    );
    dispatch(removeLoading());
  } catch (error) {
    dispatch(removeLoading());
    throw error;
  }
};

export const createBranchManager = (branchManager) => async (dispatch) => {
  try {
    dispatch(addLoading());
    await BranchManagerRequest.createBranchManager(branchManager);
    dispatch(removeLoading());
  } catch (error) {
    dispatch(removeLoading());
    throw error;
  }
};

export const deleteBranchManager = (id) => async (dispatch) => {
  try {
    dispatch(addLoading());
    await BranchManagerRequest.deleteBranchManager(id);
    dispatch(removeLoading());
  } catch (error) {
    dispatch(removeLoading());
    throw error;
  }
};

export const getBranchManagersReportCsv = () => async (dispatch) => { 
  try {
    dispatch(addLoading());
    const csvData = await BranchManagerRequest.getBranchManagersReportCsv();
    dispatch(removeLoading());
    return csvData;
  } catch (error) {
    dispatch(removeLoading());
    throw error;
  }
};